module.exports = __webpack_public_path__ + "img/electric_reserved.915f1a01.svg";